import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=29a317a9&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a317a9",
  null
  
)

export default component.exports